import React, { useState, useEffect } from 'react';
import api from '../services/api';

const LicensesPage = () => {
  const [licenseData, setLicenseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const response = await api.get('/license/check');
        const data = response.data;
        if (data.valid) {
          setLicenseData(data.license);
        } else {
          setError('License is invalid or expired');
        }
      } catch (err) {
        setError(err.response?.data?.detail || err.message || 'Error fetching license data');
      } finally {
        setLoading(false);
      }
    };

    fetchLicense();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-gray-600 dark:text-gray-400">Loading license data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 dark:text-red-400 mb-2">License Error</h2>
          <p className="text-gray-600 dark:text-gray-400">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">My Licenses</h1>
      
      {licenseData && (
        <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 border border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">License Details</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Company Name</label>
              <p className="mt-1 text-sm text-gray-900 dark:text-white">{licenseData.company_name}</p>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Expiry Date</label>
              <p className={`mt-1 text-sm ${new Date(licenseData.expiry_date) > new Date() ? 'text-green-600' : 'text-red-600'}`}>
                {licenseData.expiry_date} 
                {new Date(licenseData.expiry_date) > new Date() ? ' (Valid)' : ' (Expired)'}
              </p>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">License Key</label>
              <p className="mt-1 text-sm text-gray-900 dark:text-white font-mono">{licenseData.license_key}</p>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Issue Date</label>
              <p className="mt-1 text-sm text-gray-900 dark:text-white">{licenseData.issue_date}</p>
            </div>
            
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Verification Hash</label>
              <p className="mt-1 text-sm text-gray-900 dark:text-white font-mono break-all">{licenseData.verification}</p>
            </div>
          </div>
          
          <div className="mt-6">
            <button
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              onClick={() => window.location.reload()}  // Simple refresh to re-check
            >
              Refresh License Status
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LicensesPage;